<div class="session-detail-modal bg-light-surface dark:bg-dark-surface flex flex-col max-h-[90vh] pl-6 pr-6 pb-6">
  <!-- Main Content -->
  <div class="flex gap-6 flex-1 overflow-hidden pt-2 md:pt-4 relative">
    <!-- Toggle Button - Always absolute position -->
    <button
      (click)="toggleDetails()"
      class="absolute top-2 md:top-4 left-0 rounded-xl border border-light-border dark:border-dark-border transition-colors p-2 z-30 hover:bg-light-primary/10 dark:hover:bg-dark-primary/20"
      [matTooltip]="showDetails ? 'Ocultar detalles' : 'Ver detalles'"
      >
      <lucide-angular
        [img]="showDetails ? EyeIcon : MenuIcon"
        class="w-5 h-5 text-light-text dark:text-dark-text"
      ></lucide-angular>
    </button>

    <!-- Session Details -->
    @if (showDetails) {
      <div
        class="flex flex-col w-full md:w-auto md:relative bg-light-surface dark:bg-dark-surface z-20 md:z-0"
        >
        <!-- Header: Title -->
        <div class="flex mb-2 ml-12">
          <!-- Title - pushed right to avoid button overlap -->
          <h1>Detalles de la Sesión</h1>
        </div>
        <!-- Session Details Panel -->
        <div class="overflow-y-auto pr-4 dark:[color-scheme:dark] transition-all duration-300 flex-1">
          <div class="space-y-8">
            <!-- Session ID -->
            <div>
              <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Session ID</span>
              <div class="flex items-center gap-2 bg-light-background dark:bg-dark-background rounded-lg break-all">
                <span class="text-sm text-light-text dark:text-dark-text flex-1">{{ data.session.sessionId }}</span>
                <button mat-icon-button class="!w-5 !h-5 !p-0 flex-shrink-0" (click)="copyToClipboard(data.session.sessionId)" matTooltip="Copiar Session ID">
                  <lucide-angular [img]="CopyIcon" class="w-3.5 h-3.5 text-light-text-tertiary dark:text-dark-text-tertiary hover:text-light-primary dark:hover:text-dark-primary"></lucide-angular>
                </button>
              </div>
            </div>
            <!-- Conversation ID -->
            <div>
              <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Conversation ID</span>
              <div class="flex items-center gap-2 bg-light-background dark:bg-dark-background rounded-lg break-all">
                <span class="text-sm text-light-text dark:text-dark-text flex-1">{{ data.session.conversationId }}</span>
                <button mat-icon-button class="!w-5 !h-5 !p-0 flex-shrink-0" (click)="copyToClipboard(data.session.conversationId)" matTooltip="Copiar Conversation ID">
                  <lucide-angular [img]="CopyIcon" class="w-3.5 h-3.5 text-light-text-tertiary dark:text-dark-text-tertiary hover:text-light-primary dark:hover:text-dark-primary"></lucide-angular>
                </button>
              </div>
            </div>
            <!-- Phone Number -->
            @if (data.session.phoneNumber) {
              <div class="flex flex-col">
                <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Teléfono</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ data.session.phoneNumber }}</span>
              </div>
            }
            <!-- Started At -->
            <div class="flex flex-col">
              <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Inicio</span>
              <span class="text-sm text-light-text dark:text-dark-text">{{ formatTimestamp(data.session.startedAt) }}</span>
            </div>
            <!-- Last Activity -->
            <div class="flex flex-col">
              <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Última actividad</span>
              <span class="text-sm text-light-text dark:text-dark-text">{{ formatTimestamp(data.session.lastActivity) }}</span>
            </div>
            <!-- Current Intent -->
            @if (data.session.currentIntent) {
              <div class="flex flex-col">
                <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Intent</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ data.session.currentIntent }}</span>
              </div>
            }
            <!-- Session Source -->
            @if (data.session.sessionSource) {
              <div class="flex flex-col">
                <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Fuente</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ data.session.sessionSource }}</span>
              </div>
            }
            <!-- Was Transferred -->
            @if (data.session.wasTransfered) {
              <div class="flex flex-col">
                <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Transferida</span>
                <span class="inline-flex items-center px-3 py-2 rounded-full text-sm font-medium bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300">Sí</span>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- Messages Column -->
    @if (!showDetails) {
      <div
        class="rounded-xl mb-6 overflow-hidden border border-light-border dark:border-dark-border flex flex-col transition-all duration-300 w-full md:flex-1"
        >
        <div class="border-b border-light-border dark:border-dark-border px-4 py-3 flex items-center justify-between gap-3">
          <h3 class="light !mb-0">Mensajes</h3>
          <button
            type="button"
            (click)="openBenchmarkDialog()"
            class="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-light-border dark:border-dark-border text-light-text dark:text-dark-text hover:bg-light-bg-secondary dark:hover:bg-dark-bg-secondary transition-colors"
          >
            <span class="text-sm font-medium">Abrir benchmark</span>
          </button>
        </div>

        <div class="overflow-y-auto p-4 dark:[color-scheme:dark] flex-1">
          <app-new-message-list
            [messages]="allMessages()"
            [isViewerMode]="true"
          ></app-new-message-list>
        </div>
      </div>
    }

    <!-- Messages Column for desktop when details are shown -->
    @if (showDetails) {
      <div
        class="hidden md:flex rounded-xl overflow-hidden border border-light-border dark:border-dark-border flex-col transition-all duration-300 flex-1"
        >
        <div class="border-b border-light-border dark:border-dark-border px-4 py-3 flex items-center justify-between gap-3">
          <h3 class="light !mb-0">Mensajes</h3>
          <button
            type="button"
            (click)="openBenchmarkDialog()"
            class="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-light-border dark:border-dark-border text-light-text dark:text-dark-text hover:bg-light-bg-secondary dark:hover:bg-dark-bg-secondary transition-colors"
          >
            <span class="text-sm font-medium">Abrir benchmark</span>
          </button>
        </div>

        <div class="overflow-y-auto p-4 dark:[color-scheme:dark] flex-1">
          <app-new-message-list
            [messages]="allMessages()"
            [isViewerMode]="true"
          ></app-new-message-list>
        </div>
      </div>
    }
  </div>
</div>
